import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import {
  FlexRowCenter,
  FlexColCenterVertical,
  FlexRowCenterVertical,
  Flexbox,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';

export enum Delivery {
  ZASIELKOVNA = 'ZASIELKOVNA',
}

const Radio = styled(FlexRowCenter)`
  width: ${rem(24)};
  height: ${rem(24)};
  background: transparent;
  border: ${rem(2)} solid ${({ theme }) => theme.cartChooser.active};
  border-radius: 50%;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
`;

const InnerRadio: any = styled.div`
  width: ${rem(10)};
  height: ${rem(10)};
  background-color: ${(props: any) =>
    props.selected ? props.theme.cartChooser.active : 'transparent'};
  border-radius: 50%;
  transition: background-color 0.2s ease;
`;

const Wrapper: any = styled(FlexRowCenterVertical)`
  width: 100%;
  height: ${rem(56)};
  border-radius: ${rem(2)};
  margin-bottom: ${rem(8)};
  border: ${(props: any) =>
    props.selected ? '2px solid #D2A4B0' : '2px solid #EEEEEE'};
  transition: background-color 0.2s ease;
  padding: ${rem(16)} ${rem(24)};
  border-radius: ${rem(4)};

  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.whiteOnHover};
  }

  &:hover ${InnerRadio} {
    background-color: ${props => props.theme.cartChooser.active};
  }

  ${({ theme }) => theme.mediab.l925`
    margin-bottom: ${rem(16)};
    height: fit-content;
  `}
`;

const TextWrapper = styled(FlexColCenterVertical)`
  ${({ theme }) => theme.mediab.l925`
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
`;

const PickupPointTitle = styled(TextP)`
  font-size: ${rem(12)};
  line-height: ${rem(18)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.grey};
  margin-top: ${rem(8)};
`;

const PriceWrapper = styled(FlexRowCenter)`
  margin-left: auto;
  justify-content: flex-start;
  background: ${(props: any) =>
    props.free ? 'rgba(165, 187, 162, 0.16)' : 'rgba(210, 164, 176, 0.16)'};
  border-radius: 4px;
  padding: ${rem(3)} ${rem(8)};

  ${({ theme }) => theme.mediab.l925`
    margin-left: 0;
    margin-top: ${rem(11)};
  `}
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  color: ${(props: any) =>
    props.free ? props.theme.colors.secondary : props.theme.colors.primary};
  font-family: ${({ theme }) => theme.font.primary};
`;

const NamePriceWrapper = styled(Flexbox)`
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: start;

  ${({ theme }) => theme.mediab.l925`
    align-items: flex-start;
  `}

  ${({ theme }) => theme.mediab.l925`
    flex-direction: column;
    justify-content: center;
  `}
`;

const RadioWrapper = styled(FlexRowCenter)`
  margin-right: ${rem(16)};
`;

interface Props {
  item: any;
  selected: boolean;
  zasielkovnaPayload: any;
  postaPayload?: any;
  zasielkovna_id?: string;
  handleOptionClick: (option: any) => void;
  // hasVatrate?: boolean;
}

function OptionChooserItem({
  item,
  selected,
  zasielkovnaPayload,
  postaPayload,
  handleOptionClick,
}: // hasVatrate = true,
Props) {
  return (
    <Wrapper selected={selected} onClick={handleOptionClick}>
      <RadioWrapper>
        <Radio>
          <InnerRadio selected={selected} />
        </Radio>
      </RadioWrapper>
      <NamePriceWrapper>
        <TextWrapper>
          <Name>{item.name}</Name>
          {zasielkovnaPayload && item.id === 'ZASIELKOVNA' && (
            <PickupPointTitle>{zasielkovnaPayload.name}</PickupPointTitle>
          )}
          {postaPayload &&
            postaPayload.is_balikobox === 0 &&
            item.id === 'BALIK_NA_POSTU' &&
            postaPayload.name !== '' && (
              <PickupPointTitle>{postaPayload.name}</PickupPointTitle>
            )}
          {postaPayload &&
            postaPayload.is_balikobox === 1 &&
            item.id === 'BALIKOBOX' && (
              <PickupPointTitle>{postaPayload.name}</PickupPointTitle>
            )}
        </TextWrapper>
        {/* <PriceWrapper free={item.price === 'Zadarmo'}>
          <Price free={item.price === 'Zadarmo'}>{item.price}</Price>
        </PriceWrapper> */}
      </NamePriceWrapper>
    </Wrapper>
  );
}

export { OptionChooserItem };
